// SCR-002's routes (NAV-002 sign-in page), composed into the route table by TASK-140.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { SIGN_IN_PATH } from "./model";
import { SignIn } from "./signin";

export const routes: ScreenRoute[] = [
  defineRoute({ nav: "NAV-002", path: SIGN_IN_PATH, title: "Sign in", permission: "public", component: SignIn }),
];
